import React, { useCallback, memo } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { CheckBadgeIcon } from '@heroicons/react/24/solid';

import { PRODUCT_PRO_LINK } from '../constants'
import DefaultBadge from "../images/badge starter_n&b.png"


/**
 * PRODUCT COMPONENT
 * @param {{product: Product, badge: string, remoteProductId: string, onClick: () => void }} param0 
 * @returns {JSX.Element}
 */
function Product({ product, badge, remoteProductId, onClick }) {
  const history = useHistory()
  const subscribe = useSelector(state => state.subscriptions.product)
  const loadingSubscription = useSelector(state => state.subscriptions.loadingSubscription)

  const colors = {
    STARTER: 'green',
    'STARTER PLUS': 'secondary',
    PRO: 'blue'
  }

  const color = colors[product.title.toUpperCase()]

  const bgColor = {
    'green': 'bg-gamification-green/20',
    'secondary': 'bg-gamification-secondary/20',
    'blue': 'bg-gamification-blue/20',
  }

  const btnBg = {
    'green': 'bg-gamification-green/90 hover:bg-gamification-green',
    'secondary': 'bg-gamification-secondary/90 hover:bg-gamification-secondary',
    'blue': 'bg-gamification-blue/90 hover:bg-gamification-blue',
  }

  const textColor = {
    'green': 'text-gamification-green',
    'secondary': 'text-gamification-secondary',
    'blue': 'text-gamification-blue'
  }

  const text = product.title.toUpperCase() === 'PRO' ? "S'inscrire dès maintenant à -20%" : subscribe ? 'Choisir' : 'Tester gratuitement'
  const handleSubscribe = useCallback(() => {
    if (subscribe) {
      window.open('https://forms.office.com/r/SpNumacpZv', '_blank')
      return
    }
    if (product.title.toUpperCase() === 'PRO') {
      history.push('/contact', { link: PRODUCT_PRO_LINK })
      return
    }
    onClick(product)
  }, [subscribe, product])

  return (
    <article className={`rounded-lg flex flex-col justify-between ${product.product_id === subscribe?.product_id || remoteProductId === product.product_id ? bgColor[color] ?? 'bg-gray-50' : 'bg-white'} shadow px-4 py-3 w-[250px] max-w-[300px] space-y-3 relative ${textColor[color] ?? ''}`}>
      {
        product.product_id === subscribe?.product_id && <CheckBadgeIcon title="Votre forfait actuel" className='h-4 absolute left-2 top-2 text-inherit' />
      }
      <h3 className={`absolute right-2 ${product.product_id === subscribe?.product_id ? '-top-1' : 'top-2'}  max-w-[60px] text-center transform rotate-[20deg] uppercase text-red-500 font-bold tracking-tighter text-xs`}>{product?.highlight || 'BETA'}</h3>
      <div className='border-b border-dashed border-gray-300 flex flex-col items-center justify-center space-y-1 w-full font-semibold'>
        <img src={badge || DefaultBadge} alt={product.title} className='h-10' />
        <h3>{product.title.toUpperCase()}</h3>
      </div>
      <p className="text-center text-xs font-medium min-h-[48px]">{product.description}</p>
      <div className='text-center font-medium'>
        <h2><span className='text-3xl font-bold'>{product.price}€</span>{product.price > 0 && 'HT'}/mois {product.full_price || ''}</h2>
        {
          product.color_text_under ?
            <p style={{ color: product.color_text_under }} className='font-medium text-xs'>{product.text_under_price}</p> :
            <p className='text-gray-400 font-medium text-xs'>{product.text_under_price ?? 'Prix de lancement*'}</p>
        }
      </div>
      <div className='text-center'>
        {
          product.product_id !== subscribe?.product_id ?
            <button disabled={loadingSubscription} type='button' onClick={handleSubscribe} className={`rounded-full px-8 py-1.5 w-full uppercase tracking-wide font-medium text-xs text-white ${btnBg[color] || "bg-gray-500 hover:bg-gray-600"} hover:shadow transition-all hover:border-none disabled:text-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed`}>{text}</button> : <p className='text-teal-500 font-medium text-xs'> Votre forfait actuel</p>
        }
      </div>
    </article>
  )
}

export default memo(Product)